import { FC, PropsWithChildren, ReactNode } from "react";
import { Link } from "react-router-dom";

import ObjectInformation from "web/Pages/Checkout/TourismDomestic/SharedComponents/ObjectInformation";

import Image from "web/Layout/Common/Image";
import __ from "web/Layout/Translations";

import DetailsList from "web/Components/Common/ConfigurableDetailsList";

import type { ICartItemProductData } from "web/types/Cart";
import { PropsWithClasses } from "web/types/Common";
import { DomesticTourismCheckoutProduct } from "web/types/Product";

import classify from "web/classify";

import FEATURE_FLAGS from "web/constants/featureFlags";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import defaultStyles from "./details.scss";

interface ICheckoutProductDetailsMobileProps {
  name: string;
  image: string;
  link: string;
  additionalInfo: {
    attribute?: string;
    value: string | JSX.Element;
  }[];
  dataT1?: string;
  variant?: string;
  productData?: ICartItemProductData | DomesticTourismCheckoutProduct;
  belowDetailsList?: ReactNode;
}

const CheckoutProductDetailsMobile: FC<
  PropsWithChildren<PropsWithClasses<ICheckoutProductDetailsMobileProps>>
> = ({
  name,
  image,
  link,
  classes = {},
  additionalInfo = [],
  children,
  dataT1 = "details",
  productData,
  variant,
  belowDetailsList,
}) => {
  const isSupplierInfoEnabled = useFeatureIsOn(FEATURE_FLAGS.SUPPLIER_INFO);

  return (
    <div className={classes.root} data-t1={dataT1}>
      <Link
        className={classes.imageBox}
        to={link}
        data-t1="checkout_agreements_link"
        aria-label={`${name} - ${__("strona produktu")}`}
        aria-hidden="true"
        tabIndex={-1}
      >
        <Image
          src={image}
          className={classes.image}
          alt=""
          isProduct
          dataT1="details_image"
        />
      </Link>
      <div
        className={classes.content}
        data-t1="checkout_agreements_category_link_wrapper"
      >
        <h2 className={classes.title} data-t1="checkout_agreements_title_link">
          <Link to={link} data-t1="product_name" data-t2={name}>
            {__(name)}
            <span className="visually-hidden"> - {__("strona produktu")}</span>
          </Link>
        </h2>
        {children || null}
        <ObjectInformation
          product={productData as DomesticTourismCheckoutProduct}
        />
        <DetailsList
          className={classes.details}
          items={additionalInfo}
          variant={variant}
        />
        {isSupplierInfoEnabled ? belowDetailsList : null}
      </div>
    </div>
  );
};

export default classify<
  PropsWithChildren<PropsWithClasses<ICheckoutProductDetailsMobileProps>>
>(defaultStyles)(CheckoutProductDetailsMobile);
